import { createVanIconComponent } from "./van"

const LabelOutlined = createVanIconComponent("label-o")
export default LabelOutlined
